"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.makeReduxAuth = void 0;

var _jsonwebtoken = _interopRequireDefault(require("jsonwebtoken"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var PREFIX = '@redux-auth';

var makeReduxAuth = function makeReduxAuth(_ref) {
  var logIn = _ref.logIn,
      logOut = _ref.logOut,
      checkIfLoggedIn = _ref.checkIfLoggedIn,
      sendForgotPasswordEmail = _ref.sendForgotPasswordEmail,
      resetPassword = _ref.resetPassword;

  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      flashMessage = _ref2.flashMessage,
      flashErrorMessage = _ref2.flashErrorMessage,
      flashSuccessMessage = _ref2.flashSuccessMessage;

  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (string) {
    return string;
  };
  var SET_USER_DATA = "".concat(PREFIX, "/SET_USER_DATA");
  var SET_USER_IS_LOGGED_IN = "".concat(PREFIX, "/SET_USER_IS_LOGGED_IN");
  var SET_USER_IS_LOGGED_OUT = "".concat(PREFIX, "/SET_USER_IS_LOGGED_OUT");
  var USER_IS_LOGGING_IN = "".concat(PREFIX, "/USER_IS_LOGGING_IN");
  var USER_LOGIN_FAILURE = "".concat(PREFIX, "/USER_LOGIN_FAILURE");

  var resetPasswordAsyncAction = function resetPasswordAsyncAction(password, data) {
    return function (dispatch) {
      flashMessage && dispatch(flashMessage(t('Resetting password in progress')));
      return resetPassword(password, data).then(function () {
        return flashSuccessMessage && dispatch(flashSuccessMessage(t('Password reset! You can login now!')));
      }).catch(function (err) {
        console.log(err, err.response.data); // eslint-disable-line no-console

        flashErrorMessage && dispatch(flashErrorMessage(t('Error when resetting password! Try again!')));
      });
    };
  };

  var sendForgotPasswordEmailAsyncAction = function sendForgotPasswordEmailAsyncAction(email) {
    return function (dispatch) {
      flashMessage && dispatch(flashMessage(t('Sending email in progress')));
      return sendForgotPasswordEmail(email).then(function () {
        return flashSuccessMessage && dispatch(flashSuccessMessage(t('E-mail with instructions was sent!')));
      }).catch(function (err) {
        console.log(err, err.response.data); // eslint-disable-line no-console

        if (err.response.data.message === 'No such user!') {
          flashErrorMessage && dispatch(flashErrorMessage(t('No such user!')));
        } else {
          flashErrorMessage && dispatch(flashErrorMessage(t('Something went wrong!')));
        }
      });
    };
  };

  var loginSuccessful = function loginSuccessful(dispatch) {
    return function (userData) {
      var accessToken = userData.accessToken,
          refreshToken = userData.refreshToken;
      flashSuccessMessage && dispatch(flashSuccessMessage(t('Logged in successfully!')));
      dispatch(setUserDataAction(_jsonwebtoken.default.decode(accessToken)));
      dispatch(setUserIsLoggedInAction(accessToken, refreshToken));
      return userData;
    };
  };

  var handleErrorNotification = function handleErrorNotification(dispatch, error) {
    var message = error && error.response && error.response.data && error.response.data.message || error.message;
    console.log(error, message); // eslint-disable-line no-console

    var displayedErrors = {
      'Invalid password': t('Invalid password!'),
      'User not found!': t('User not found!')
    };
    var notDisplayedErrors = ['No token in storage!'];

    if (Object.keys(displayedErrors).includes(message)) {
      flashErrorMessage && dispatch(flashErrorMessage(t('Login failure! - ') + displayedErrors[message]));
    } else if (!notDisplayedErrors.includes(message)) {
      flashErrorMessage && dispatch(flashErrorMessage(t('Unknown authorization problem!')));
    }
  };

  var loginFailed = function loginFailed(dispatch) {
    return function (error) {
      handleErrorNotification(dispatch, error);
      dispatch(userLoginFailureAction(error));
      dispatch(setUserIsLoggedOutAction());
      return error;
    };
  };

  var createLogInAsyncAction = function createLogInAsyncAction(logInFromDb) {
    return function (email, password) {
      return function (dispatch, getState) {
        flashMessage && dispatch(flashMessage(t('Logging in')));
        dispatch(userIsLoggingInAction());
        return logInFromDb(email, password).then(loginSuccessful(dispatch)).catch(loginFailed(dispatch));
      };
    };
  };

  var logInAsyncAction = createLogInAsyncAction(logIn);

  var createCheckIfLoggedInAsyncAction = function createCheckIfLoggedInAsyncAction(checkIfLoggedInFromDb) {
    return function () {
      return function (dispatch, getState) {
        dispatch(userIsLoggingInAction());
        return checkIfLoggedInFromDb().then(loginSuccessful(dispatch)).catch(loginFailed(dispatch));
      };
    };
  };

  var checkIfLoggedInAsyncAction = createCheckIfLoggedInAsyncAction(checkIfLoggedIn);

  var createLogOutAsyncAction = function createLogOutAsyncAction(logOutFormDb) {
    return function () {
      return function (dispatch, getState) {
        return logOutFormDb().then(function () {
          dispatch(setUserIsLoggedOutAction());
        });
      };
    };
  };

  var logOutAsyncAction = createLogOutAsyncAction(logOut);

  var setUserDataAction = function setUserDataAction(userData) {
    return {
      type: SET_USER_DATA,
      userData: userData
    };
  };

  var setUserIsLoggedInAction = function setUserIsLoggedInAction(accessToken, refreshToken) {
    return {
      type: SET_USER_IS_LOGGED_IN,
      accessToken: accessToken,
      refreshToken: refreshToken
    };
  };

  var setUserIsLoggedOutAction = function setUserIsLoggedOutAction() {
    return {
      type: SET_USER_IS_LOGGED_OUT
    };
  };

  var userIsLoggingInAction = function userIsLoggingInAction() {
    return {
      type: USER_IS_LOGGING_IN
    };
  };

  var userLoginFailureAction = function userLoginFailureAction(loginError) {
    return {
      type: USER_LOGIN_FAILURE,
      loginError: loginError
    };
  };

  var initialState = {
    isUserLoggedIn: false,
    accessToken: null,
    refreshToken: null,
    userData: null,
    userIsLoggingIn: false,
    loginError: null
  };

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case SET_USER_IS_LOGGED_IN:
        return _objectSpread({}, state, {
          isUserLoggedIn: true,
          userIsLoggingIn: false,
          accessToken: action.accessToken,
          refreshToken: action.refreshToken,
          loginError: initialState.loginError
        });

      case SET_USER_IS_LOGGED_OUT:
        return _objectSpread({}, initialState, {
          loginError: state.loginError
        });

      case SET_USER_DATA:
        return _objectSpread({}, state, {
          userData: action.userData
        });

      case USER_IS_LOGGING_IN:
        return _objectSpread({}, state, {
          userIsLoggingIn: true
        });

      case USER_LOGIN_FAILURE:
        return _objectSpread({}, state, {
          loginError: action.loginError,
          userIsLoggingIn: false
        });

      default:
        return state;
    }
  };

  return {
    resetPasswordAsyncAction: resetPasswordAsyncAction,
    sendForgotPasswordEmailAsyncAction: sendForgotPasswordEmailAsyncAction,
    logInAsyncAction: logInAsyncAction,
    checkIfLoggedInAsyncAction: checkIfLoggedInAsyncAction,
    logOutAsyncAction: logOutAsyncAction,
    setUserDataAction: setUserDataAction,
    setUserIsLoggedInAction: setUserIsLoggedInAction,
    setUserIsLoggedOutAction: setUserIsLoggedOutAction,
    userIsLoggingInAction: userIsLoggingInAction,
    userLoginFailureAction: userLoginFailureAction,
    reducer: reducer
  };
};

exports.makeReduxAuth = makeReduxAuth;
var _default = makeReduxAuth;
exports.default = _default;